import styled from "styled-components";
import { Icon } from "@ebscois/react-component-library";

export const AudioWrapper = styled.span`
  position: relative;
  top: 0.2rem;
  margin-left: 0.4rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    top: 0;
  }
`;
export const AudioButton = styled.button`
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
`;
export const StyledAudioIcon = styled(Icon)`
  height: 20px;
  width: 20px;
  vertical-align: text-bottom;
  fill: ${({ theme }) => theme.colors.anchor};
  @media print {
    display: none;
  }

  &:hover {
    cursor: pointer;
    fill: ${({ theme }) => theme.colors.gray600};
  }
`;
